import { apiRequest } from "./http";

export interface SignupPayload {
    name: string;
    email: string;
    password: string;
    plan_id?: number;
}

export interface SignupResponse {
    message?: string;
    [key: string]: unknown;
}

export interface LoginPayload {
    email: string;
    password: string;
}

export interface AuthUser {
    id?: number;
    name?: string;
    email?: string;
    is_admin?: boolean;
}

export interface LoginResponse {
    success?: boolean;
    message?: string;
    data?: {
        token?: string;
        user?: AuthUser;
    };
    token?: string;
    user?: AuthUser;
    [key: string]: unknown;
}

export function signup(payload: SignupPayload) {
    return apiRequest<SignupResponse>({
        endpoint: "/auth/signup",
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function login(payload: LoginPayload) {
    return apiRequest<LoginResponse>({
        endpoint: "/auth/login",
        method: "POST",
        body: JSON.stringify(payload),
    });
}
